"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERC721TokenReceiver__factory = exports.ERC721__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var ERC721__factory_1 = require("./ERC721__factory");
Object.defineProperty(exports, "ERC721__factory", { enumerable: true, get: function () { return ERC721__factory_1.ERC721__factory; } });
var ERC721TokenReceiver__factory_1 = require("./ERC721TokenReceiver__factory");
Object.defineProperty(exports, "ERC721TokenReceiver__factory", { enumerable: true, get: function () { return ERC721TokenReceiver__factory_1.ERC721TokenReceiver__factory; } });
//# sourceMappingURL=index.js.map